import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

function CollectionIcon(props) {
    return (
        <SvgIcon {...props}>
            <g transform="translate(-1198 -137)">
                <rect className="a" fill="none" width="24" height="24" transform="translate(1198 137)" />
                <path className="b" fill="#616161" d="M2,15H12V13H2Zm0,4H12V17H2Zm0-8H12V9H2ZM2,5V7H12V5Z" transform="translate(1198 137)" />
                <path className="b" fill="#616161" d="M20,8a2,2,0,1,0-2-2A2.006,2.006,0,0,0,20,8Zm-4,8a2,2,0,1,0,2,2A2.006,2.006,0,0,0,16,16Zm4-4a2,2,0,1,0,2,2A2.006,2.006,0,0,0,20,12ZM16,8a2,2,0,1,0,2,2A2.006,2.006,0,0,0,16,8Z" transform="translate(1198 137)" />
            </g>
        </SvgIcon>
    );
}

export default CollectionIcon;